(ns core.front.media-query
  (:require [core.front.event :refer [>evt]]
            [re-frame.core-instrumented :as rf]))


(def min-widths
  "These should match the Tailwind screen defined in config/tailwind.config.js"
  [[:xxl 1600]
   [:xl 1280]
   [:lg 1024]
   [:md 768]
   [:sm 640]])




(defn on-resize-update []
  (->> min-widths
       (keep (fn [[bp min-width]]
               (when (.-matches (.matchMedia js/window (str "(min-width: " min-width "px)")))
                 bp)))
       set
       (vector ::set-matching-breakpoints)
       >evt))


(defn init []
  ;; Init can be called multiple times at least when developing with shadow-cljs reloading, but adding
  ;; the same static function as listener should be a no-op.
  (.addEventListener js/window "resize" on-resize-update)
  (on-resize-update))


(rf/reg-event-db ::set-matching-breakpoints
  (fn [db [_ breakpoints]]
    (assoc db ::currently-matching-breakpoints breakpoints)))


(rf/reg-sub ::currently-matching-breakpoints :-> ::currently-matching-breakpoints)


(rf/reg-sub ::breakpoint-matches?
  :<- [::currently-matching-breakpoints]
  (fn [breakpoints [_ bp]]
    (contains? breakpoints bp)))
